import type { JourneyKey } from "./plan.types";

/**
 * Manual completion belongs to a journey, not to a generic step name such as
 * "learn" or "test". Scoping the persisted key prevents a completed step in
 * one treatment intent from leaking into another intent.
 */
export function getJourneyStepCompletionId(
  journeyKey: JourneyKey,
  stepId: string,
): string {
  return `${journeyKey}:${stepId}`;
}
